import { useEffect } from "react";

const DEFAULT_TITLE = "ClarityPoint Consulting | Technology, AI & Digital Engineering";
const DEFAULT_DESC = "ClarityPoint Consulting helps businesses build scalable digital products, modernize technology platforms and unlock the power of AI, cloud and data.";
const ROBOTS_DEFAULT = "index, follow, max-image-preview:large, max-snippet:-1";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, noindex = false, jsonLd }) {
  useEffect(() => {
    const t = title || DEFAULT_TITLE;
    const d = description || DEFAULT_DESC;
    document.title = t;
    setMeta("name", "description", d);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : ROBOTS_DEFAULT);
    setMeta("property", "og:title", t);
    setMeta("property", "og:description", d);
    setMeta("name", "twitter:title", t);
    setMeta("name", "twitter:description", d);

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "page-jsonld";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      document.title = DEFAULT_TITLE;
      setMeta("name", "description", DEFAULT_DESC);
      setMeta("name", "robots", ROBOTS_DEFAULT);
      setMeta("property", "og:title", DEFAULT_TITLE);
      setMeta("property", "og:description", DEFAULT_DESC);
      setMeta("name", "twitter:title", DEFAULT_TITLE);
      setMeta("name", "twitter:description", DEFAULT_DESC);
      if (script) script.remove();
    };
  }, [title, description, noindex, jsonLd]);
  return null;
}
